import { render, staticRenderFns } from "./PromoNotificationAdmin.vue?vue&type=template&id=62557d4f&"
import script from "./PromoNotificationAdmin.vue?vue&type=script&lang=js&"
export * from "./PromoNotificationAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports